import React from 'react';

function Startseite() {
    return (
        <div className="element-content element-background">
            <div className="startseite-container">
                <div className="startseite-header">
                    <h1 className="startseite-title">Armbrustliga</h1>
                    <h2 className="startseite-subtitle">Ligaverwaltung & Wettkampforganisation</h2>
                </div>
                
                <div className="startseite-content">
                    <div className="info-section">
                        <h3 className="info-title">Über die Ligaverwaltung</h3>
                        <p>
                            Anzeigen und Verwalten des Ligabetriebs der Armbrustliga.
                        </p>
                        <p>
                            Die Seite ist aktuell in Entwicklung und wird ständig erweitert.
                        </p>
                    </div>
                    
                    <div className="news-section">
                        <h3 className="news-title">Aktuelle Informationen</h3>
                        
                        <div className="news-card">
                            <h4 className="news-headline">
                                Finale 10m 2025 - in Oldenburg
                            </h4>
                            <p className="news-text">
                                Zum Jahreshöhepunkt in der 10m Armbrust konnte die SG Zaitzkofen ihren Titel denkbar knapp verteidigen.
                            </p>
                            <a 
                                href="https://sv-etzhorn.de/artikel/krone-verteidigt-zaitzkofen-triumphiert-erneut-beim-bundesliga-finale-am-landesstuetzpunkt-in-etzhorn/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="news-link"
                            >
                                Erfahren sie mehr, im Artikel des SV Etzhorn→
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Startseite;
